import React from 'react';
import MathJax from '../../../../components/react-mathjax-preview';
import SFWindow from './SFWindow';

const SFFeedbackPopup = ({ feedback, visibility, closeClick }) => {
    console.debug("visibility>>??", visibility)
    return (
        <React.Fragment>
            {visibility ? (
                <SFWindow
                    title='Feedback on your Answer'
                    onClose={closeClick}
                    showMaximizeIcon={true}
                    defaultWidth={400}
                    defaultHeight={300}
                >
                    <MathJax math={feedback} />
                </SFWindow>
            ) : null}
        </React.Fragment>
    );
}

export default SFFeedbackPopup;